<page-header title="DIGITIZATION"></page-header>
<card>
  <digitization-map></digitization-map>
</card>
